import axios from "axios";
import { message } from "antd";

axios.interceptors.response.use(null, error => {
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

  if(!expectedError){
    message.error("Ha ocurrido un error inesperado!");
  }

  return Promise.reject(error);
});

export function setAuthorization(token) {
  if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function deleteAuthorization(){
  delete axios.defaults.headers.common["Authorization"];
}

export function setDefaultHeaders(customer, organization){
  if(customer) axios.defaults.headers.common["customerId"] = customer
  if(organization) axios.defaults.headers.common["organizationId"] = organization
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    patch: axios.patch,
    setAuthorization,
    deleteAuthorization,
    setDefaultHeaders
}


// WEBPACK FOOTER //
// ./src/services/httpService.js